/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnterpriseCustomerIdDto } from './enterpriseCustomerIdDto';
import { ImplementDataDto } from './implementDataDto';
import { EmployeeDataDto } from './employeeDataDto';
import { MachineDataDto } from './machineDataDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface TaskV2Dto {
  comment?: string;
  customer?: EnterpriseCustomerIdDto;
  dataArchived?: boolean;
  dataUpdating?: boolean;
  employeeData?: Array<EmployeeDataDto>;
  employeeDataGeometry?: Array<EmployeeDataDto>;
  id?: number;
  implementData?: Array<ImplementDataDto>;
  implementDataGeometry?: Array<ImplementDataDto>;
  machineData?: Array<MachineDataDto>;
  machineDataGeometry?: Array<MachineDataDto>;
  name?: string;
  owner?: EnterpriseIdDto;
  start?: string;
  stop?: string;
  syren?: boolean;
}
